import React from 'react'

import { TAG_TYPES } from '@utils/constants'
//TODO - decide if we want icons or just nuke all this

// import Church from '@components/Icons/Church'
// import MapMarker from '@components/Icons/MapMarker'
// import Category from '@components/Icons/Tag'

import styles from './styles.module.css'

const Tags = ({ entry }) => {
  // const getIcon = type => {
  //   const icons = {
  //     country: <MapMarker />,
  //     fcpId: <Church />,
  //     category: <Category />
  //   }

  //   return icons[type] || null
  // }

  return (
    <ul className={styles.tags}>
      {Object.entries(TAG_TYPES)
        .sort(([, a], [, b]) => a.sortOrder - b.sortOrder)
        .map(([type, tag]) => (
          <li key={type}>
            <h3>{entry.tags[type] ?? '---'}</h3>
            <div>
              {/* {getIcon(type)} */}
              <p>{tag.label}</p>
            </div>
          </li>
        ))}
    </ul>
  )
}

export default Tags
